import React from 'react';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';

import Home from './screen/Home';
import Login from './screen/Login';
import Clients from './screen/Clients';
import Policies from './screen/Policies';
import Sinesters from './screen/Sinesters';
import Settings from './screen/Settings';
import PolicyRenew from './screen/PolicyRenew';
import SinesterWizard from './screen/SinesterWizard';

const App = () => (
  <Router>
    <div>
      <Route exact path="/" component={Home} />
      <Route exact path="/auth" component={Login} exact={true} />
      <Route path="/clients" component={Clients}/>
      <Route path="/policies" component={Policies} exact={true} />
      <Route path="/policies/:id" component={Policies} exact={true}/>
      <Route path="/policy-renew" component={PolicyRenew} exact={true} />
      <Route path="/policies-rewnew/:id" component={PolicyRenew} exact={true}/>
      <Route path="/sinesters" component={Sinesters} exact={true}/>
      <Route path="/sinesters/:id" component={Sinesters} exact={true}/>
      <Route path="/sinester-new" component={SinesterWizard} exact={true}/>
      <Route path="/settings" component={Settings}/>
    </div>
  </Router>
)

export default App


// WEBPACK FOOTER //
// ./src/App.jsx